module.exports = __webpack_public_path__ + "img/logo-no-wordmark-dark.b462b0bb.svg";